module.exports = __webpack_public_path__ + "img/image6.1fd174c3.png";